/**
* @Description 文件功能说明：上传预览弹窗
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   append-to-body
                   v-dialogDrag
                   class="dialog_title"
                   @close="handleDialogClose"
        >
            <!-- 表格 -->
            <el-table :data="tableData"
                      ref="tableData"
                      stripe
                      style="width: 100%;"
                      :class="{'table': true, 'no-pagination': true}">
                <el-table-column label="序号" width="80">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="(scope.row.passDistance > 0 ? ('与上一个基站的距离' + scope.row.lastBsDistance + '米，站间距超过' + scope.row.passDistance + '米') : '')">
                          {{scope.row.sort}} <i class="el-icon-warning" v-if="scope.row.passDistance > 0"></i>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="基站编号" width="120">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title='scope.row.bsId + " (" + scope.row.bsSid + ")"'>{{scope.row.bsShortId + " (" + scope.row.bsSid + ")"}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="安装序号,高度/米" width="160">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="'安装序号：' + scope.row.bsSerial + '\n安装高度：' + scope.row.pointZ + ' 米'">{{ (scope.row.bsSerial==null?"":scope.row.bsSerial)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{(scope.row.pointZ==null?"":scope.row.pointZ)}}</span>
                    </template>
                </el-table-column>
<!--                <el-table-column label="基站组" min-width="120">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.bsGroupNames.join(' | ')">{{scope.row.bsGroupNames.join(" | ")}}</span>
                    </template>
                </el-table-column>-->
                <el-table-column label="相对上一个基站" width="180">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="('X方向: ' + (scope.row.directionX?'正':'反') + '\nY方向: ' + (scope.row.directionY?'正':'反'))">{{'X方向: ' + (scope.row.directionX?'正':'反') + ' | Y方向: ' + (scope.row.directionY?'正':'反')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="垂直距离/米" width="160">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="('垂直于' + (scope.row.verticalDirection==1?'X':'Y') + '轴：' + scope.row.verticalDistance)">{{'垂直于' + (scope.row.verticalDirection==1?'X':'Y') + '轴：' + scope.row.verticalDistance}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="测距值/米" width="120">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.range">{{scope.row.range}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="坐标X,Y/米" width="160">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title='scope.row.pointX == null ? "": (scope.row.pointX + ", " + scope.row.pointY)'>{{scope.row.pointX == null? "": (scope.row.pointX + ", " + scope.row.pointY)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="远程地址" width="180">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.bsRemoteAddr">{{scope.row.bsRemoteAddr}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="测距状态" width="200" v-if="rangeStatus != 0">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="rangeStatusDetail[scope.row.rangeStatus]">{{rangeStatusDetail[scope.row.rangeStatus]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" v-if="rangeStatus == 0">
                    <template v-slot="scope">
                      <div v-if="scope.$index == tableData.length-1">
                        <el-dropdown split-button type="info" size="mini" @click="addRow(scope.row, scope.$index)" trigger="click">
                          <i class="el-icon-circle-plus-outline" title="插入"></i>
                          <el-dropdown-menu slot="dropdown" trigger="click">
                            <el-dropdown-item  icon="el-icon-top" type="success"  @click.native="updateSort(scope.row, scope.$index, false)" trigger="click">向上移动</el-dropdown-item>
                            <el-dropdown-item  icon="el-icon-edit" type="success"  @click.native="editRow(scope.row, scope.$index)" trigger="click">编辑基站</el-dropdown-item>
                            <el-dropdown-item  icon="el-icon-delete" type="warning" @click.native="deleteRow(scope.row, scope.$index)" trigger="click">删除基站</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                      <div v-else>
                        <el-button-group>
                          <el-dropdown split-button type="info" size="mini" @click="startRange(scope.row)" trigger="click">
                            <i class="el-icon-caret-right" title="开始测距"></i>
                            <el-dropdown-menu slot="dropdown" trigger="click">
                              <el-dropdown-item  icon="el-icon-top" type="success"  @click.native="updateSort(scope.row, scope.$index, false)" trigger="click">向上移动</el-dropdown-item>
                              <el-dropdown-item  icon="el-icon-bottom" type="success"  @click.native="updateSort(scope.row, scope.$index, true)" trigger="click">向下移动</el-dropdown-item>
                              <el-dropdown-item  icon="el-icon-circle-plus-outline" type="success"  @click.native="addRow(scope.row, scope.$index)" trigger="click">插入基站</el-dropdown-item>
                              <el-dropdown-item  icon="el-icon-edit" type="success"  @click.native="editRow(scope.row, scope.$index)" trigger="click" v-if="true">编辑基站</el-dropdown-item>
                              <el-dropdown-item  icon="el-icon-delete" type="warning" @click.native="deleteRow(scope.row, scope.$index)" trigger="click">删除基站</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                          <el-button type="info" size="mini" icon="el-icon-setting" @click="setRow(scope.row, scope.$index)" title="设置第一个基准基站的坐标"></el-button>
                        </el-button-group>
                      </div>
                    </template>
                </el-table-column>
            </el-table>

            <UwbBSRangeInsertDialog ref="uwbBSRangeInsertDialog" :unRangeBs="unRangeBs" :insertBs="insertBs" @research="research" />
            <UwbBSRangeSetDialog ref="uwbBSRangeSetDialog" :setBs="setBs" :rangeGroupId="groupId" @research="research" />
            <UwbBSRangeEditDialog ref="uwbBSRangeEditDialog" :editRangeBs="editRangeBs" :rangeGroupId="groupId" @research="research" />

            <!-- webSoket 组件 -->
            <SubWebsoket  v-if="wsFilter.creatWsFlag"
                          ref="selfRangeWs"
                          :wsUrl="wsFilter.wsUrl"
                          :wsKey="wsFilter.wsKey"
                          :autoRecreatFlag="wsFilter.autoRecreatFlag"
                          :wsOnopen="wsFilter.wsOnopen"
                          :wsOnmessage="wsFilter.wsOnmessage"
                          :winMessageFn="wsFilter.winMessageFn"
            />

            <el-form :inline="true" :model="rangeForm" ref="rangeForm">
                <div style="float: right;width: 450px;">
	                <el-form-item label="有效测距数：" prop="rangeNum">
	                    <el-input v-model="rangeForm.rangeNum" type="number" size="mini" min="5" @blur="updateRangeNum" :disabled="rangeStatus!=0" style="padding-top: 0px;"/>
	                </el-form-item>
	                <el-form-item label="站间距误差：" prop="rangeError">
	                    <el-input v-model="rangeForm.rangeError" @blur="updateRangeError" :disabled="rangeStatus!=0" size="mini" style="padding-top: 5px;">
	                        <template slot="append">米</template>
	                    </el-input>
	                </el-form-item>
	                <el-form-item style="float: right;">
	                    <el-button type="info" size="mini" @click="endRange()" trigger="click" v-if="rangeStatus!=0">结束测距</el-button>
	                </el-form-item>
                </div>
                
                
                <el-form-item width="600px" style="float: left;">
                    <p>注：第一个基站作为基准基站，需要设置基站坐标；屏幕显示向右为X轴正方向，向下为Y轴正方向</p>
                    <p v-if="rangeStatus==1 && rangePackage">
                        <span v-if="rangePackage.bs && rangePackage.bs.length == 2">
                            序号{{rangePackage.bs[0].sort}}的基准基站编号：{{rangePackage.bs[0].bsSid}}
                            , 序号{{rangePackage.bs[1].sort}}的测距基站编号：{{rangePackage.bs[1].bsSid}}
                        </span>
                        <span v-if="rangePackage.status && rangePackage.status > 0">
                            , 状态：{{rangeDetail[rangePackage.status]}}
                        </span>
                        <span v-if="rangePackage.range">
                            , 第{{rangeNo}}个测距平均值(米)：{{rangePackage.range}}
                        </span>
                        <span v-if="rangePackage.pointBean">
                            , 坐标X,Y,Z(米)：{{rangePackage.pointBean.posX + ', ' + rangePackage.pointBean.posY + ', ' +  + rangePackage.pointBean.posZ}}} ,
                        </span>
                    </p>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>

</template>

/* JS */
<script>

import DynamicTable from '@/components/DynamicTable.vue'
import ApiOam from '@/request/api-oam'
import UwbBSRangeInsertDialog from "./UwbBSRangeInsertDialog";
import UwbBSRangeSetDialog from "./UwbBSRangeSetDialog";
import UwbBSRangeEditDialog from "./UwbBSRangeEditDialog";
// websocket
import SubWebsoket from '@/components/SubWebsoket'
// 组件
import GlobalVar from '@/global/global-variable'
import Secret from "@/secret";

export default {

    /**
     * @Des 组件名
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    name: 'UwbBSRangeDialog',

    props: {
        /**
         * @Des 测距组
         * @Auth Zhangbin
         * @Date 17:23 2021/4/30
         */
        rangeGroup: {
            type: Object,
            default: function (){
                return {}
            }
        }
    },

    /**
     * @Des 组件引用
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    components: {
        UwbBSRangeEditDialog,
        UwbBSRangeSetDialog,
        UwbBSRangeInsertDialog,
        // 动态表格
        DynamicTable,
        SubWebsoket
    },

    /**
     * @Des 数据定义
     * @Auth Zhangbin
     * @Date 17:23 2021/4/30
     */
    data() {
        return{
            /**
             * @Des 弹出层属性
             * @Auth Zhangbin
             * @Date 17:23 2021/4/30
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
                submitButton: '',
            },
            operationLock: false,
            tableData: [],
            index: -1,
            bsGroups: [],
            groupId: 0,
            unRangeBs: [],
            insertBs: {},
            setBs: {},
            editRangeBs: {},
            rangeStatus: 0,
            rangeNo: 0,
            rangeStatusDetail: {
                0: '等待测距',
                1: '自测距中',
                2: '完成测距'
            },
            rangeDetail: {
                0: '等待测距',
                1: '设置成功',
                2: '设置失败',
                3: '测距成功',
                4: '测距失败',
                5: '自测距中',
                6: '完成测距',
            },
            rangePackage: {},
            rangeForm: {
                bsGroupIds : [],
                pointX : null,
                pointY : null,
                pointZ : null,
                rangeNum: 10,
                rangeError: 1
            },
            // websoket
            wsFilter:{
                // 创建 ws flag
                creatWsFlag: false,
                // webSoket路径
                wsUrl: GlobalVar.WS_OAM_PATH,
                // webSoket key
                wsKey: '_Self_Range',
                // 自动重新连接
                autoRecreatFlag: true,
                // 连接已打开
                wsOnopen: this.wsOnopen,
                // 数据推送
                wsOnmessage: this.wsOnmessage,
                // 无 this.wsOnmessage 时，onmessage 监听回调 {方法名称}
                winMessageFn: null,
                // this.onMessage 与 this.wsOnmessage 存一即可
            },// wsFilter
        }
    },

    /**
     * @Des 方法定义
     * @Auth Zhangbin
     * @Date 17:24 2021/4/30
     */
    methods: {

        /**
         * @Des 打开弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        openDialog(title, button){
            this.dialogTreeItem.title = title;
            this.dialogTreeItem.dialogFormVisible = true;
            this.dialogTreeItem.submitButton = button;
            this.flushTable();
            this.wsFilter.creatWsFlag = true;
        },

        flushTable(){
            this.tableData = Object.assign([], []);
            this.index = -1;
            this.rangeForm.bsGroupIds = null;
            this.rangeForm.pointX = null;
            this.rangeForm.pointY = null;
            this.rangeForm.pointZ = null;
            if(this.rangeForm.rangeNum == '') this.rangeForm.rangeNum = 10;
            this.$nextTick(() => {
                if(this.rangeGroup){
                    this.rangeStatus = this.rangeGroup.status;
                    this.groupId = this.rangeGroup.groupId;
                    this.index = this.rangeGroup.index;
                    this.bsGroups = this.rangeGroup.bsGroups;
                    this.rangeForm.rangeNum = this.rangeGroup.rangeNum;
                    this.rangeGroup.bsSelfRanges.forEach((r, i) => {
                        let bs = this.rangeGroup.bsMap[r.bsSid];
                        if(i == 0){
                            if(bs.pointX != null) this.rangeForm.pointX = bs.pointX;
                            if(bs.pointY != null) this.rangeForm.pointY = bs.pointY;
                            if(bs.pointZ != null) this.rangeForm.pointZ = bs.pointZ;
                            if(bs.groupIds != null) this.rangeForm.bsGroupIds = bs.groupIds;
                        }
                        let groupNames = []
                        if(bs.groupIds != null){
                            bs.groupIds.forEach((r2, i2) => {
                                groupNames.push(bs.bsGroupMap[r2].groupName);
                            })
                        }
                        // console.log(groupNames);
                        this.tableData.push({
                            bsId: bs.bsId,
                            bsShortId: bs.shortId,
                            bsSid: bs.sid,
                            bsSerial: bs.bsSerial,
                            bsGroupIds: bs.groupIds,
                            bsGroupNames: groupNames,
                            bsStatus: bs.status,
                            bsStatusName: bs.status==1?'在线': '离线',
                            bsRemoteAddr: (bs.uwbIp==null||bs.uwbIp=='')?"":(bs.uwbIp+":"+bs.uwbPort),
                            pointX: bs.pointX,
                            pointY: bs.pointY,
                            pointZ: bs.pointZ,
                            groupId: r.groupId,
                            directionX: r.directionX,
                            directionY: r.directionY,
                            verticalDirection: r.verticalDirection,
                            verticalDistance: r.verticalDistance,
                            rangeStatus: r.status,
                            range: r.range,
                            sort: r.sort,
                            projectId: r.projectId,
                            edit: false,
                            passDistance: r.passDistance?parseFloat(r.passDistance).toFixed(3): 0,
                            lastBsDistance: r.lastBsDistance?parseFloat(r.lastBsDistance).toFixed(3): 0,
                        })
                    })
                }
            })
        },

        /**
         * @Des 关闭弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        handleDialogClose(){
            this.dialogTreeItem.dialogFormVisible = false;
            this.$emit("research");
            this.wsFilter.creatWsFlag = false;
        },

        /**
         * @Author ZhangBin
         * @Description //TODO 开始测距
         * @Date 11:23 2022/5/19
         * @Param
         * @return
         **/
        startRange(row){
            if(this.operationLock) return;
            if(this.tableData.length < 2){
                this.$message({
                    message: "至少有两个基站，才可以进行测距",
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return;
            }
            let rangeBs = row;
            let offline = false;
            let startIndex = -1;
            this.tableData.forEach((r, index)=>{
              if(row.bsSid == r.bsSid && startIndex == -1 ){
                  startIndex = index;
              }
              if(startIndex != -1 && r.bsStatus != 1){
                  offline = true;
              }
            });
            if(offline){
                this.$message({
                    message: "有基站处于离线状态，不能进行连续测距",
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return;
            }
            if(rangeBs.bsGroupIds == null || rangeBs.bsGroupIds.length == 0 || rangeBs.bsSerial == ''
                || rangeBs.pointX == null || rangeBs.pointY == null || rangeBs.pointZ == null
            ){
                this.$message({
                    message: "请先设置第一个基站的坐标信息",
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return;
            }
            this.$confirm(
                '确定要开始测距吗？','询问',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal : false,
                    type: 'warning'
                }
            ).then(_ => {
                this.operationLock = true;
                this.$request.postJsonRequest(ApiOam.Start_Uwb_Range_Uri, {
                    groupId: this.groupId,
                    startBsSid: row.bsSid
                }).then(result => {
                    if(result.code == 0){
                        this.rangeStatus = 1;
                        this.rangePackage = Object.assign({}, {});
                        this.$message({
                            message: "开始测距...",
                            type: 'info',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'info',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                    this.operationLock = false;
                }).catch(error => {
                	this.operationLock = false;
                    console.error('开始测距异常', ApiOam.Start_Uwb_Range_Uri, error);
                })
            });
        },

        /**
         * @Author ZhangBin
         * @Description //TODO 开始测距
         * @Date 11:23 2022/5/19
         * @Param
         * @return
         **/
        endRange(){
            if(this.operationLock) return;
            this.$confirm(
                '确定要结束测距吗？','询问',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal : false,
                    type: 'warning'
                }
            ).then(_ => {
                this.operationLock = true;
                this.$request.postJsonRequest(ApiOam.End_Uwb_Range_Uri, {
                    groupId: this.groupId,
                }).then(result => {
                    if(result.code == 0){
                        this.rangeStatus = 0;
                        this.rangePackage = Object.assign({}, {});
                        this.$message({
                            message: "测距结束...",
                            type: 'info',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'info',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                    this.operationLock = false;
                }).catch(error => {
                	this.operationLock = false;
                	console.error('结束测距异常', ApiOam.End_Uwb_Range_Uri, error);
                })
            });

        },

        /**
         * @Author ZhangBin
         * @Description //TODO 插入
         * @Date 11:23 2022/5/19
         * @Param
         * @return
         **/
        addRow(row, index){
            if(this.operationLock) return;
            this.operationLock = true;
            this.insertBs = row;
            this.unRangeBs = [];
            this.$request.postJsonRequest(ApiOam.Find_Uwb_Bs_By_ProjectId_Uri, {
                projectId: row.projectId,
                unRange: false
            }).then(result => {
                console.log(result)
                if(result.code == 0){
                    this.unRangeBs = result.data;
                }
                if(this.unRangeBs.length > 0){
                    this.$refs.uwbBSRangeInsertDialog.openDialog("插入测距基站", "确定插入");
                }else{
                    this.$message({
                        message: "未找到新的测距基站",
                        type: 'info',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                }
              this.operationLock = false;
            }).catch(error => {
              this.operationLock = false;
                console.error('插入测距基站异常', ApiOam.Find_Uwb_Bs_By_ProjectId_Uri, error);
            })
        },

        /**
         * @Author ZhangBin
         * @Description //TODO 编辑
         * @Date 11:23 2022/5/19
         * @Param
         * @return
         **/
        setRow(row, index){
            this.setBs = row;
            this.$refs.uwbBSRangeSetDialog.openDialog("设置第一个基站的坐标", "确定", {
                bsGroups: this.bsGroups
            })
        },

        /**
         * @Author ZhangBin
         * @Description //TODO 编辑
         * @Date 11:23 2022/5/19
         * @Param
         * @return
         **/
        editRow(row, index){
            // console.log(row);
            this.editRangeBs = row;
            this.$refs.uwbBSRangeEditDialog.openDialog("编辑测距基站", "确定", {
                bsGroups: this.bsGroups,
                index: index,
                maxSort: this.tableData.length
            })
        },

        /**
         * @Author ZhangBin
         * @Description //TODO 编辑
         * @Date 11:23 2022/5/19
         * @Param
         * @return
         **/
        deleteRow(row, index){
            if(this.operationLock) return;
            if(this.tableData.length <= 2){
                this.$message({
                    message: "至少有两个基站才能进行测距",
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return;
            }
            this.$confirm(
                '确认删除测距基站：'+row.bsShortId+' ('+row.bsSid+') 吗？','询问',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal : false,
                    type: 'warning'
                }
            ).then(_ => {
                this.operationLock = true;
                this.$request.postJsonRequest(ApiOam.Delete_Uwb_Range_Bs_Uri, {
                    groupId: row.groupId,
                    bsSid: row.bsSid
                }).then(result => {
                    if(result.code == 0){
                        this.$message({
                            message: "删除成功",
                            type: 'info',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.research();
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'warning',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                  this.operationLock = false;
                }).catch(error => {
                  this.operationLock = false;
                    console.error('删除测距基站异常', ApiOam.Delete_Uwb_Range_Bs_Uri, error);
                })
            });
        },

        /**
         * @Author ZhangBin
         * @Description //TODO  重新查询数据
         * @Date 9:16 2022/5/20
         * @Param
         * @return
         **/
        research(){
            this.$emit("research")
        },

        /**
         * @Author ZhangBin
         * @Description //TODO 修改测距数量
         * @Date 9:06 2022/5/20
         * @Param
         * @return
         **/
        updateRangeNum() {
            if(this.operationLock) return;
            if(this.rangeForm.rangeNum == ''){
                this.rangeForm.rangeNum = 10;
            }
            if(this.rangeForm.rangeNum > 300){
                this.rangeForm.rangeNum = 300;
            }else if(this.rangeForm.rangeNum < 1){
                this.rangeForm.rangeNum = 1;
            }
           this.operationLock = true;
            // console.log(this.rangeForm.rangeNum);
            this.$request.postJsonRequest(ApiOam.Update_Uwb_Range_Num_Uri, {
                groupId: this.groupId,
                rangeNum: this.rangeForm.rangeNum,
            }).then(result => {
                if(result.code == 0){
                    this.research();
                }
              this.operationLock = false;
            }).catch(error => {
              this.operationLock = false;
              console.error('修改测距数量异常', ApiOam.Update_Uwb_Range_Num_Uri, error);
            })
        },
        /**
         * @Author ZhangBin
         * @Description //TODO 修改测距数量
         * @Date 9:06 2022/5/20
         * @Param
         * @return
         **/
        updateRangeError() {
          if(this.operationLock) return;
            if(this.rangeForm.rangeError == ''){
                this.rangeForm.rangeError = 1;
            }
          this.operationLock = true;
            // console.log(this.rangeForm.rangeNum);
            this.$request.postJsonRequest(ApiOam.Update_Uwb_Range_Error_Uri, {
                groupId: this.groupId,
                rangeError: this.rangeForm.rangeError,
            }).then(result => {
                if(result.code == 0){
                    this.research();
                }
              this.operationLock = false;
            }).catch(error => {
              this.operationLock = false;
              console.error('修改测距误差异常', ApiOam.Update_Uwb_Range_Error_Uri, error);
            })
        },

        // webSoket 连接打开 onopen回调
        wsOnopen(event) {
            console.log('bs self range websocket server connect success');
            this.sendWsData();
        },
        // webSoket 数据推送   onmessage回调
        wsOnmessage(event) {
            const data = eval('(' + event.data + ')');
            if(data.code == 14){
                this.rangePackage = eval('(' + data.data + ')');
                // console.log(this.rangePackage);
                const status = this.rangePackage.status;
                if(status == 1){
                    // 设置成功
                    this.rangeNo = 0;
                    this.searchBsSelfRange();
                }else if(status == 2){
                    // 设置失败
                }else if(status == 3){
                    // 测距成功
                    /*if(this.rangePackage.bs && this.rangePackage.bs.length == 2){
                        this.tableData[this.rangePackage.bs[0].sort-1].rangeStatus = this.rangePackage.bs[0].status;
                        this.tableData[this.rangePackage.bs[1].sort-1].rangeStatus = this.rangePackage.bs[1].status;
                        this.tableData[this.rangePackage.bs[1].sort-1].range = this.rangePackage.range;
                    }*/
                    this.searchBsSelfRange();
                }else if(status == 4){
                    // 测距失败
                }else if(status == 5){
                    // 自测距中
                    if(this.rangePackage.bs && this.rangePackage.bs.length == 2){
                        this.rangeNo++;
                        this.tableData[this.rangePackage.bs[0].sort-1].rangeStatus = this.rangePackage.bs[0].status;
                        this.tableData[this.rangePackage.bs[1].sort-1].rangeStatus = this.rangePackage.bs[1].status;
                        this.tableData[this.rangePackage.bs[1].sort-1].range = this.rangePackage.range;
                    }
                    if(this.rangePackage.point){
                        this.tableData[this.rangePackage.bs[1].sort-1].pointX = parseFloat(this.rangePackage.point.posX).toFixed(3);
                        this.tableData[this.rangePackage.bs[1].sort-1].pointY = parseFloat(this.rangePackage.point.posY).toFixed(3);
                        this.searchBsSelfRange();
                    }
                }else if(status == 6){
                    // 完成测距
                    this.rangeStatus = 0;
                    this.rangePackage = Object.assign({}, {});
                }
            }
        },
        // webSoket 数据推送   onmessage回调
        wsOnerror(event) {
            const data = eval('(' + event.data + ')');
            console.log(data);
        },
        // webSoket 数据推送   onmessage回调
        wsOnclose(event) {
            const data = eval('(' + event.data + ')');
            console.log(data);
        },
        sendWsData(){
            if(!this.wsFilter.creatWsFlag){
                return;
            }
            const code = 14;
            const time = new Date().getTime();
            const sign = Secret.md5(time + "{" + code + "}");
            const argJson = {
                code: code,
                time: time,
                sign: sign
            };
            this.$refs.selfRangeWs.wsSend(argJson);
        },

        searchBsSelfRange(){
            this.$request.postJsonRequest(ApiOam.Find_Uwb_Range_Bs_By_GroupId_Uri, {
                groupId: this.groupId,
            }).then(result => {
                // console.log(result);
                if(result.code == 0){
                    this.tableData = Object.assign([], []);
                    if(result.data){
                        result.data.bsSelfRanges.forEach((r, i) => {
                            if(result.data.bsMap[r.bsSid]){
                                let bs = result.data.bsMap[r.bsSid];
                                this.tableData.push({
                                    bsId: bs.bsId,
                                    bsShortId: bs.shortId,
                                    bsSid: bs.sid,
                                    bsSerial: bs.bsSerial,
                                    bsGroupIds: bs.groupIds,
                                    // bsGroupNames: groupNames,
                                    bsStatus: bs.status,
                                    bsStatusName: bs.status==1?'在线': '离线',
                                    bsRemoteAddr: (bs.uwbIp==null||bs.uwbIp=='')?"":(bs.uwbIp+":"+bs.uwbPort),
                                    pointX: bs.pointX,
                                    pointY: bs.pointY,
                                    pointZ: bs.pointZ,
                                    groupId: r.groupId,
                                    directionX: r.directionX,
                                    directionY: r.directionY,
                                    verticalDirection: r.verticalDirection,
                                    verticalDistance: r.verticalDistance,
                                    rangeStatus: r.status,
                                    range: r.range,
                                    sort: r.sort,
                                    projectId: r.projectId,
                                    edit: false
                                })
                            }
                        })
                    }
                }else{
                    this.$message({
                        message: result.msg,
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                }
            }).catch(error => {
                console.error('查询测距基站异常', ApiOam.Find_Uwb_Range_Bs_By_GroupId_Uri, error);
            })
        },
        /**
         * @Author ZhangBin
         * @Description //TODO 修改排序
         * @Date 12:59 2022/6/29
         * @Param
         * @return
         **/
        updateSort(row, index, direction){
          if(this.operationLock) return;
          this.operationLock = true;
          // console.log(row, index, direction)
          this.$request.postJsonRequest(ApiOam.Update_Uwb_Range_Bs_Sort_Uri, {
            groupId: this.groupId,
            bsSid: row.bsSid,
            sort: direction?(row.sort+1):(row.sort-1)
          }).then(result => {
            // console.log(result);
            if(result.code == 0){
              this.research();
            }else{
              this.$message({
                message: result.msg,
                type: 'warning',
                showClose: true,
                dangerouslyUseHTMLString: true
              });
            }
            this.operationLock = false;
          }).catch(error => {
            this.operationLock = false;
            console.error('修改测距基站排序异常', ApiOam.Update_Uwb_Range_Bs_Sort_Uri, error);
          })
        }


    },

}
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 1400px;
		max-width: 90%;
        height: 80%;
	}
	/deep/ .el-dialog__body {
		height: 100%;
	}
	/deep/ .form-dialog {
		
		.el-select{
			width: auto;
		}
		
		.el-form,
		.el-form-item {
			margin-bottom: 0px;
		}
		
		.el-form-item__content {
			line-height: 38px;
		}
		
		.el-table.no-pagination {
			height: calc(100% - 100px);
		}
		
	}/* .form-dialog */
	
    /deep/ .el-input .el-input__inner{
        width: 80px;
    }
    /deep/ .el-select .el-input__inner{
        width: 100px;
    }
    /deep/ .el-button-group .el-button{
        width: 50px;
        height: 34px;
        line-height: 34px;
    }
    /deep/ .el-form-item .el-button{
        height: 34px;
        line-height: 34px;
    }
    
    /*@media only screen and (max-width: 1469px) {
    	.el-table.no-pagination {
			height: calc(100% - 100px);
		}
    }*/
</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbBSRangeDialog.vue